import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ProjectDTO } from 'cargo-chief-commons';

import { CarrierToProjectsMap } from '@domain/interface/carrier-to-projects-map';
import { UtilService } from '@service/util/util.service';
import { SearchPipe } from '@shared/search.pipe';
import { MatLegacySlideToggle as MatSlideToggle } from '@angular/material/legacy-slide-toggle';

@Component({
	selector: 'app-projects-icon',
	templateUrl: './projects-icon.component.html',
	styleUrls: ['./projects-icon.component.scss'],
	providers: [SearchPipe],
})
export class ProjectsIconComponent implements OnInit {
	@Input() projects: Array<ProjectDTO> = null;
	@Input() carrierToProjectsMap: Array<CarrierToProjectsMap> = null;
	@Input() nextPage: boolean = false;
	@Input() isLoadingProjectsList: boolean = false;
	@Input() totalNumberOfProjects = null;
	@Input() carrierIDs: Array<string> = null;
	@Input() searchTruckForm: null;
	@Input() isCarrierSearch: boolean = false;
	@Input() projectSource: string = '';
	@Input() projectsLimit: number = 10;

	@Output() carrierProjectToggled: EventEmitter<any> = new EventEmitter();
	@Output() loadMoreProjects: EventEmitter<any> = new EventEmitter();
	@Output() reloadList: EventEmitter<any> = new EventEmitter();

	searchText;

	constructor(public utilService: UtilService) {}

	ngOnInit() {}

	projectToggled(
		project: CarrierToProjectsMap,
		isCarrierAddedToProject: boolean,
		slideToggleRef: MatSlideToggle
	) {
		this.carrierProjectToggled.emit({ project, isCarrierAddedToProject, slideToggleRef });
	}

	viewMoreProjects() {
		if (
			!this.utilService.isNullOrUndefined(this.totalNumberOfProjects) &&
			!this.utilService.isNullOrUndefined(this.carrierToProjectsMap)
		) {
			if (
				this.totalNumberOfProjects != this.carrierToProjectsMap.length &&
				this.carrierToProjectsMap.length <= this.projectsLimit
			) {
				this.isLoadingProjectsList = true;
				setTimeout(() => {
					this.loadMoreProjects.emit();
				}, 0);
			}
			this.projectsLimit += 10;
		}
	}

	onSearchTextChange(searchText) {
		if (
			searchText?.length &&
			!this.isLoadingProjectsList &&
			this.projectsLimit < this.totalNumberOfProjects
		) {
			this.fetchAllProjectsList();
		}
	}

	fetchAllProjectsList() {
		setTimeout(() => {
			if (this.projectsLimit > this.totalNumberOfProjects || !this.searchText?.length) {
				return;
			}
			if (!this.isLoadingProjectsList && this.projectsLimit < this.totalNumberOfProjects) {
				this.viewMoreProjects();
			}
			this.fetchAllProjectsList();
		}, 300);
	}
}
